<template>
  <canvas id="map"></canvas>
</template>

<script>
export default {
  name: 'MapView',
  props: {
    floor: Number,
    path: Array,
    position: Object,
    selected_rooms: Array,
    blueprint: Path2D,
    metadata: Object
  },
  data() {
    return {
      context: null,
      mouseX: 0,
      mouseY: 0,
      scale: 1,
      zoom: 1,
      mouse_down: false,
      translate: { x: 0, y: 0 }
    }
  },
  mounted() {
    this.context = document.getElementById('map').getContext('2d')
    this.context.canvas.style.cssText = ''

    document.getElementById('map').onmouseup = event => {
      this.mouse_down = false

      for(let i = 0; i < this.metadata.rooms.length; i++) {
        if(this.mouse_touches(this.metadata.rooms[i].boundary_box)) {
          this.$emit('room_selected', {
            name: this.metadata.rooms[i].name,
            floor: this.floor,
            src: this.metadata.rooms[i].name==='Main Office'
              ? require('../assets/office.svg')
              : this.metadata.rooms[i].name==='Cafeteria'
              ? require('../assets/cafeteria.svg')
              : this.metadata.rooms[i].name==='Clinic'
              ? require('../assets/health.svg')
              : this.metadata.rooms[i].name==='Library'
              ? require('../assets/library.svg')
              : this.metadata.rooms[i].name==='Auditorium'
              ? require('../assets/auditorium.svg')
              : this.metadata.rooms[i].name==='Main Gym' || this.metadata.rooms[i].name==='Aux Gym'
              ? require('../assets/gym.svg')
              : this.metadata.rooms[i].name==='Boys Locker Room' || this.metadata.rooms[i].name==='Girls Locker Room'
              ? require('../assets/locker.svg')
              : this.metadata.rooms[i].name==='Weight Room'
              ? require('../assets/weights.svg')
              : this.metadata.rooms[i].name==='Wrestling Room'
              ? require('../assets/wrestling.svg')
              : this.metadata.rooms[i].name==='Studio'
              ? require('../assets/dancer.svg')
              : require('../assets/classroom.svg')
          })
        }
      }

      this.context.canvas.style.cursor = 'default'
    }

    document.getElementById('map').onmousedown = () => this.mouse_down = true

    document.onmousemove = event => {
      if (this.mouse_down) {
        this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height)
        this.context.canvas.style.cursor = 'grabbing'

        this.translate.x += event.movementX / this.scale
        this.translate.y += event.movementY / this.scale
      }

      this.mouseX = event.clientX/this.scale - this.translate.x
      this.mouseY = event.clientY/this.scale - this.translate.y
    }

    document.getElementById('map').onwheel = event => {
      let offset = this.zoom
      if (this.zoom+event.deltaY*-0.01 > 0.2 && this.zoom+event.deltaY*-0.01 < 2)
        this.zoom += event.deltaY * -0.01
      offset -= this.zoom

      this.translate.x += (this.mouseX+this.translate.x) * offset
      this.translate.y += (this.mouseY+this.translate.y) * offset
    }

    this.update()
  },
  watch: {
    floor: {
      deep: true,
      immediate: true, 
      handler(old_floor, new_floor) {
        this.zoom = 1

        if(window.innerWidth/window.innerHeight > this.metadata.width/this.metadata.height) {
          const scale = window.innerHeight/this.metadata.height
          this.translate.x = (window.innerWidth/scale - this.metadata.width)/2
          this.translate.y = 0
        } else {
          const scale = window.innerWidth/this.metadata.width
          this.translate.x = 0
          this.translate.y = (window.innerHeight/scale - this.metadata.height)/2
        }
      }
    }
  },
  methods: {
    update() {
      requestAnimationFrame(this.update)

      this.context.canvas.width = window.innerWidth
      this.context.canvas.height = window.innerHeight
      if(this.context.canvas.width/this.context.canvas.height > this.metadata.width/this.metadata.height) {
        this.scale = this.context.canvas.height/this.metadata.height*this.zoom
        this.context.scale(this.scale, this.scale)
      } else {
        this.scale = this.context.canvas.width/this.metadata.width*this.zoom
        this.context.scale(this.scale, this.scale)
      }

      let touching_room = false
      if(this.floor) {
        this.context.clearRect(0, 0, this.context.canvas.width, this.context.canvas.height)
        this.context.translate(this.translate.x, this.translate.y)

        this.context.strokeStyle = '#abb5a4'
        this.context.textAlign = 'center'
        this.context.textBaseline = 'middle'

        this.metadata.rooms.concat(this.metadata.staircases).forEach(room => {
          if(room.name && this.mouse_touches(room.boundary_box) && this.context.canvas.style.cursor !== 'grabbing' || this.selected_rooms.includes(room.name)) {
            this.context.fillStyle = '#eeebe3'

            if (!this.selected_rooms.includes(room.name)) {
              touching_room = true
              this.context.canvas.style.cursor = 'pointer'
            }

            this.context.beginPath()
            this.context.moveTo(room.boundary_box[0][0], room.boundary_box[0][1])
            for(let j = 1; j < room.boundary_box.length; j++)
              this.context.lineTo(room.boundary_box[j][0], room.boundary_box[j][1])
            this.context.fill()
          }

          if (this.position.x!==null && this.position.y!==null && this.position.z===this.floor) {
            this.context.fillStyle = '#a0e3f5'
            this.context.beginPath()
            this.context.arc(this.position.x, this.position.y, 25/this.zoom, 0, 2*Math.PI)
            this.context.fill()
            this.context.fillStyle = '#5bd3fa'
            this.context.beginPath()
            this.context.arc(this.position.x, this.position.y, 17.5/this.zoom, 0, 2*Math.PI)
            this.context.fill()
          }

          this.context.fillStyle = '#9f9e9c'
          this.context.font = '13px Rubik, sans-serif'

          const label = room.name || room.global_stair_index
          const bound_width = Math.abs(room.text_boundary[2]-room.text_boundary[0])
          const s_x = bound_width / this.context.measureText(label).width
          if (this.context.measureText(label).width+3 > bound_width && !label.includes(' '))
            this.context.font = `${13*s_x-1}px Rubik, sans-serif`

          if (label.includes(' ') && this.context.measureText(label).width+3 > bound_width) {
            const line_count = label.split(' ').length
            label.split(' ').forEach((line, i) => {
              this.context.fillText(
                line,
                (room.text_boundary[0]+room.text_boundary[2])/2,
                (room.text_boundary[3]+room.text_boundary[1]-line_count*15+15)/2+i*15
              )
            })
          } else {
            this.context.fillText(
              room.name || room.global_stair_index,
              (room.text_boundary[0]+room.text_boundary[2])/2,
              (room.text_boundary[1]+room.text_boundary[3])/2
            )
          }
        })

        this.context.stroke(this.blueprint)

        this.context.lineWidth = 5
        this.context.lineCap = 'round'
        this.context.lineJoin = 'round'
        this.context.strokeStyle = '#7cb9e8'
        for(let i = 0; i < this.path.length; i++)
          if(this.floor === this.path[i].floor)
            this.context.stroke(this.path[i].path)
        this.context.lineWidth = 5
        this.context.lineCap = 'butt'
        this.context.lineJoin = 'miter'

        if (this.position.x!==null && this.position.y!==null && this.position.z===this.floor) {
          this.context.fillStyle = '#fff'
          this.context.beginPath()
          this.context.arc(this.position.x, this.position.y, 7.5/this.zoom, 0, 2*Math.PI)
          this.context.fill()
          this.context.fillStyle = '#00bfff'
          this.context.beginPath()
          this.context.arc(this.position.x, this.position.y, 5/this.zoom, 0, 2*Math.PI)
          this.context.fill()
        }
      }

      if (!touching_room && this.context.canvas.style.cursor !== 'grabbing')
        this.context.canvas.style.cursor = 'default'
    },
    mouse_touches(boundary_box) {
      let inside = false

      for (let i = 0, j = boundary_box.length - 1; i < boundary_box.length; j = i++)
        if (((boundary_box[i][1] > this.mouseY) != (boundary_box[j][1] > this.mouseY)) && (this.mouseX < (boundary_box[j][0] - boundary_box[i][0]) * (this.mouseY - boundary_box[i][1]) / (boundary_box[j][1] - boundary_box[i][1]) + boundary_box[i][0]))
          inside = !inside
      
      return inside
    }
  }
}
</script>

<style>
#map {
  display: flex;
  width: 100vw;
  height: 100vh;
  align-items: center;
  justify-content: center;
}

#canvas {
  user-select: none;
  touch-action: none;
  transform-origin: 50% 50%;
}
</style>
